import _ from 'underscore';
import accordion from '../../../LegacyComponents/accordion.js'

(function () {
    "use strict";

    var moduleObj = moduler('individualsAndFamiliesFormsDownload', _({
        data: {

        },

        defaults: {
            defaultSecondDropdownValue: '-- Select a Report --',

            listChangeEvent: 'change',

            categoryFirstSelection: '[data-template=CategoryFirstSelection]',
            categoryLastSelection: '[data-template=CategoryLastSelection]',
            categorySelectorTemplate: '[data-template=CategorySelectorItem]',
            categorySelectorArea: '[data-section=CategorySelector]',
            categoryDescriptionContainer: '[data-template=CategoryItemDescriptor]',
            categoryDescriptionSelector: '[data-category={0}]',

            subCategoryContainer: '[data-section=SubCategoryContainer]',
            subcategorySelectorTemplate: '[data-template=SubCategorySelectorItem]',
            subcategorySelectorArea: '[data-section=SubCategorySelector]',

            actionExpandableContainer: '[data-section=ActionExpandableContainer]',

            actionSelectorTemplate: '[data-template=ActionExpandableItem]',
            actionSelectorTemplateWithChildren: '[data-template=ActionExpandableItemWithChildren]',

            actionSelectorArea: '[data-section=ActionExpandable]',

            actionSelectorSubitemTemplate: '[data-template=ActionExpandableSubItem]',
            actionSelectorSubitemTemplateWithChildren: '[data-template=ActionExpandableSubItemWithChildren]',
            downloadSummaryAreaTemplate: '[data-template=DownloadSummaryArea]',
            singleDownloadButtonTemplate: '[data-template=SingleDownloadButton]',
            multipleDownloadButtonTemplate: '[data-template=MultipleDownloadButons]',

            formDownloadSummaryContainer: '[data-section=FormDownloadSummaryContainer]',
            formDownloadSummaryArea: '[data-section=FormDownloadSummaryArea]',

            disabledClass: 'Box--disabled',
            hideShowToggleClass: 'u-hiddenVisually',
        },

        init: function (module) {
            module.$categoryFirstSelection = $(module.settings.categoryFirstSelection);
            module.$categoryLastSelection = $(module.settings.categoryLastSelection);

            module.$categorySelectorTemplate = $(module.settings.categorySelectorTemplate);
            module.$categorySelectorArea = $(module.settings.categorySelectorArea);

            module.$subCategoryContainer = $(module.settings.subCategoryContainer);
            module.$subcategorySelectorTemplate = $(module.settings.subcategorySelectorTemplate);
            module.$subcategorySelectorArea = $(module.settings.subcategorySelectorArea);

            module.$actionExpandableContainer = $(module.settings.actionExpandableContainer);
            module.$actionSelectorTemplate = $(module.settings.actionSelectorTemplate);
            module.$actionSelectorTemplateWithChildren = $(module.settings.actionSelectorTemplateWithChildren);
            module.$actionSelectorArea = $(module.settings.actionSelectorArea);

            module.$actionExpandableSubItem = $(module.settings.actionSelectorSubitemTemplate);
            module.$actionExpandableSubItemWithChildren = $(module.settings.actionSelectorSubitemTemplateWithChildren);

            module.$downloadSummaryAreaTemplate = $(module.settings.downloadSummaryAreaTemplate);

            module.$formDownloadSummaryContainer = $(module.settings.formDownloadSummaryContainer);
            module.$formDownloadSummaryArea = $(module.settings.formDownloadSummaryArea);

            module.$formDownloadSingleButtonTemplate = $(module.settings.singleDownloadButtonTemplate);
            module.$formDownloadMultipleButtonTemplate = $(module.settings.multipleDownloadButtonTemplate);

            moduleObj.actions.initializeOptions(module);
        },

        listen: {

            changedCategoryOption: mo.event(function (module, event) {
                var $currentTarget = $(event.currentTarget);
                moduleObj.data.selections.category = _(moduleObj.data.productCategories).findWhere({ guid: $currentTarget.val() });

                // TODO: Refactor out GA event
                if (typeof gtag !== 'undefined' && !!moduleObj.data.selections.category) {
                    gtag('event', 'Select Product Category', {
                        'event_category': 'I&F Forms',
                        'event_label': moduleObj.data.selections.category.name + " [" + moduleObj.data.selections.category.guid + "]"
                    });
                }

                moduleObj.actions.setupSubCategories(module);
            }),

            changedSubCategoryOption: mo.event(function (module, event) {
                var $currentTarget = $(event.currentTarget);

                moduleObj.data.selections.subcategory = _(moduleObj.data.selections.category.terms).findWhere({ guid: $currentTarget.val() });

                // TODO: Refactor out GA event
                if (typeof gtag !== 'undefined' && !!moduleObj.data.selections.subcategory) {
                    gtag('event', 'Select Product Category', {
                        'event_category': 'I&F Forms',
                        'event_label': moduleObj.data.selections.subcategory.name + " [" + moduleObj.data.selections.subcategory.guid + "]"
                    });
                }

                moduleObj.actions.calculateApplicableForms(module); // Filters forms used in finding the formActions

                moduleObj.actions.setupFormActions(module);
            }),

            clickedFormAction: mo.event(function (module, event) {
                event.preventDefault();
                //console.log('event::', event)

                var $currentTarget = $(event.currentTarget).find(".Expandable-link-tier");

                if (!!window.MSInputMethodContext && !!document.documentMode) {
                    //is ie11
                    var $elem = event.currentTarget.selectedIndex
                    var selectedFormId = $(event.currentTarget).find('option:selected').data('form-id');
                } else {
                    var $elem = event.currentTarget.selectedOptions[0].index
                    var selectedFormId = event.currentTarget.selectedOptions[0].dataset.formId
                }

                //console.warn('selectedFormId', selectedFormId)

                $(".Expandable-link-tier", $currentTarget.parents(".Expandable")).removeClass("is-active"); // Close other panels
                $currentTarget.addClass("is-active");

                moduleObj.actions.displayDownloadForForm(module, selectedFormId);
            }),

            clickedEmailFormModal: mo.event(function (module, event) {
                var $formPanel = $(".email-forms-modal", module.$element);

                $("[data-bind=email-form-formids]").val(moduleObj.data.selections.selectedFormIds);
            }),

            clickedDownloadButton: mo.event(function (module, event) {
                var applicableForms = moduleObj.data.selections.applicableForms;
                var specifiedForm = _(applicableForms).findWhere({ formId: moduleObj.data.selections.selectedFormIds });

                // TODO: Refactor GA Event
                if (typeof gtag !== 'undefined' && !!specifiedForm) {
                    gtag('event', 'Download Form', {
                        'event_category': 'I&F Forms',
                        'event_label': specifiedForm.documentTitle + " [" + specifiedForm.formId + "]"
                    });
                }
            })
        },

        fn: {


        },

        actions: {

            initializeOptions: function (module) {
                var pageId = module.$element.data("page-id");
                var blockId = module.$element.data("block-id");

                moduleObj.shared.parseWidgetDataFromJson(pageId, blockId).then(function (blockData) {
                    moduleObj.data = blockData;

                    moduleObj.actions.registerEvents(module);
                    moduleObj.actions.setupCategories(module);
                });
            },

            registerEvents: function (module) {
                module.$element.on("click", "[data-modal].email-forms-button", module, moduleObj.listen.clickedEmailFormModal);
                module.$element.on("click", module.settings.formDownloadSummaryArea + " .Button[href]", module, moduleObj.listen.clickedDownloadButton);
            },

            setupCategories: function (module) {
                // Data for categories
                var categories = moduleObj.data.productCategories;

                moduleObj.actions.resetCategories(module);

                var containerInnerHtml = $(module.settings.categoryDescriptionContainer).html();
                var $categoryDescriptionContainer = $(containerInnerHtml);

                module.$categorySelectorArea.append(moduleObj.actions.getTemplateFromElement(module.$categoryFirstSelection));

                for (var x = 0; x < categories.length; x++) {
                    var categorySelectionOptionTemplate = moduleObj.actions.getTemplateFromElement(module.$categorySelectorTemplate);

                    categorySelectionOptionTemplate = categorySelectionOptionTemplate.replace(/\{numItems\}/g, categories.length);
                    categorySelectionOptionTemplate = categorySelectionOptionTemplate.replace(/\{0\}/g, x);
                    categorySelectionOptionTemplate = categorySelectionOptionTemplate.replace(/\{1\}/g, categories[x].name);
                    categorySelectionOptionTemplate = categorySelectionOptionTemplate.replace(/\{2\}/g, categories[x].guid);

                    var $categoryDescription = $categoryDescriptionContainer.find("[data-category='" + categories[x].name + "']");

                    if ($categoryDescription.length > 0) {
                        var categoryDescription = $categoryDescription.html();
                        categorySelectionOptionTemplate = categorySelectionOptionTemplate.replace(/\{4\}/g, "display: block;");
                        categorySelectionOptionTemplate = categorySelectionOptionTemplate.replace(/\{5\}/g, categoryDescription);
                    } else {
                        categorySelectionOptionTemplate = categorySelectionOptionTemplate.replace(/\{4\}/g, "display: none;");
                    }

                    var checkedString = (moduleObj.data.selections.category == categories[x]) ? "selected" : undefined;
                    categorySelectionOptionTemplate = categorySelectionOptionTemplate.replace(/\{3\}/g, checkedString);
                    module.$categorySelectorArea.append(categorySelectionOptionTemplate);
                }

                module.$categorySelectorArea.append(moduleObj.actions.getTemplateFromElement(module.$categoryLastSelection));
                moduleObj.actions.registerCategoryChangeEvents(module);
            },

            setupSubCategories: function (module) {
                var subcategories = moduleObj.data.selections.category.terms;

                subcategories = _(subcategories).chain().filter(function (subcategoryToFilter) {
                    return moduleObj.actions.calculateApplicableFormsForValues(moduleObj.data.selections.category.guid, subcategoryToFilter.guid).length > 0;
                }).sortBy("name").value();

                moduleObj.actions.resetSubCategories(module);

                module.$subcategorySelectorArea.append(moduleObj.actions.getTemplateFromElement(module.$categoryFirstSelection));

                for (var x = 0; x < subcategories.length; x++) {
                    var categorySelectionOptionTemplate = moduleObj.actions.getTemplateFromElement(module.$subcategorySelectorTemplate);

                    categorySelectionOptionTemplate = categorySelectionOptionTemplate.replace(/\{0\}/g, x);
                    categorySelectionOptionTemplate = categorySelectionOptionTemplate.replace(/\{1\}/g, subcategories[x].name);
                    categorySelectionOptionTemplate = categorySelectionOptionTemplate.replace(/\{2\}/g, subcategories[x].guid);

                    var checkedString = (moduleObj.data.selections.subcategory == subcategories[x]) ? "checked" : undefined;
                    categorySelectionOptionTemplate = categorySelectionOptionTemplate.replace(/\{3\}/g, checkedString);

                    module.$subcategorySelectorArea.append(categorySelectionOptionTemplate);
                }

                module.$subcategorySelectorArea.append(moduleObj.actions.getTemplateFromElement(module.$categoryLastSelection));
                module.$subCategoryContainer.removeClass(module.settings.disabledClass);

                moduleObj.actions.registerSubCategoryChangeEvents(module);
            },

            setupFormActions: function (module) {
                moduleObj.actions.resetFormActions(module);

                var formActions = moduleObj.actions.getApplicableFormAudiences(module);
                var partialGetSubitem = _.partial(moduleObj.actions.getFormActionSubitem, module);

                module.$actionSelectorArea.append(moduleObj.actions.getTemplateFromElement(module.$categoryFirstSelection));

                for (var x = 0; x < formActions.length; x++) {
                    var formAction = formActions[x];
                    var itemTemplate = moduleObj.actions.getTemplateFromElement(module.$actionSelectorTemplate);

                    var applicableFormsForAction = moduleObj.actions.getApplicableFormsForAction(module, formAction);
                    var applicableFormsSubitemsHtml = _(applicableFormsForAction).map(partialGetSubitem);
                    var applicableFormsSubitemHtml = applicableFormsSubitemsHtml.join(""); // Join with nothing, not comma

                    itemTemplate = itemTemplate.replace(/\{0\}/g, x);
                    itemTemplate = itemTemplate.replace(/\{1\}/g, formAction.actionName);
                    itemTemplate = itemTemplate.replace(/\{2\}/g, formAction.guid);
                    itemTemplate = itemTemplate.replace(/\{3\}/g, applicableFormsSubitemHtml);

                    module.$actionSelectorArea.append(itemTemplate);
                }

                module.$actionSelectorArea.append(moduleObj.actions.getTemplateFromElement(module.$categoryLastSelection));
                module.$actionExpandableContainer.removeClass(module.settings.disabledClass);

                moduleObj.actions.registerFormActionsEvents(module);
            },

            resetCategories: function (module) {
                module.$categorySelectorArea.empty();
                moduleObj.actions.resetSubCategories(module);
            },

            resetSubCategories: function (module) {
                module.$subcategorySelectorArea.empty();
                module.$subCategoryContainer.addClass(module.settings.disabledClass);

                moduleObj.actions.resetFormActions(module);
            },

            resetFormActions: function (module) {
                module.$actionSelectorArea.empty();
                module.$actionExpandableContainer.addClass(module.settings.disabledClass);

                moduleObj.actions.resetDownloadSummary(module);
            },

            resetFormActionsCopy: function (module) {
                //module.$actionSelectorArea.empty();
                //module.$actionExpandableContainer.addClass(module.settings.disabledClass);

                moduleObj.actions.resetDownloadSummary(module);
            },

            resetDownloadSummary: function (module) {
                module.$formDownloadSummaryArea.empty();
                module.$formDownloadSummaryContainer.addClass(module.settings.disabledClass);
            },

            registerCategoryChangeEvents: function (module) {
                module.$categorySelectorArea.on("change", module, moduleObj.listen.changedCategoryOption);
                symetra.downloadForm.init();
            },

            registerSubCategoryChangeEvents: function (module) {
                module.$subcategorySelectorArea.on("change", module, moduleObj.listen.changedSubCategoryOption);
                // move this into module
                symetra.downloadForm.init();
            },

            registerFormActionsEvents: function (module) {
                module.$actionSelectorArea.off("change").on("change", module, moduleObj.listen.clickedFormAction);

                // Animation
                module.$actionSelectorArea.find(".Expandable-link option").on("click", function (event) {
                    event.preventDefault();
                    var $target = $(event.currentTarget);
                    var $itemContainer = $target.parent();

                    // TODO: Refactor out GA event
                    var formActionName = $target.text();
                    if (typeof gtag !== 'undefined' && !!formActionName) {
                        gtag('event', 'Select Form Action', {
                            'event_category': 'I&F Forms',
                            'event_label': formActionName
                        });
                    }

                    $target.toggleClass("is-active");
                    $(".Accordion-panel", $itemContainer.siblings()).removeClass("is-active"); // Close other panels
                    $(".Expandable-link", $itemContainer.siblings()).removeClass("is-active"); // Remove is-active from link in other panels (+/- icon)
                    $itemContainer.find(".Accordion-panel").toggleClass("is-active");
                });
            },

            calculateApplicableForms: function (module) {
                var applicableForms = moduleObj.actions.calculateApplicableFormsForValues(moduleObj.data.selections.category.guid, moduleObj.data.selections.subcategory.guid);

                moduleObj.data.selections.applicableForms = applicableForms;
            },

            calculateApplicableFormsForValues: function (categoryGuid, subcategoryGuid) {
                var productIdentifierPrefix = categoryGuid + "|" + subcategoryGuid;

                var applicableForms = _(moduleObj.data.forms).chain().filter(function (form) {
                    var appliesToFilterCriteria = _(form.productIdentifiers).some(function (productIdent) {
                        return productIdent.indexOf(productIdentifierPrefix) == 0; // Starts with
                    });

                    return appliesToFilterCriteria;
                }).value();

                return applicableForms;
            },

            getApplicableFormAudiences: function (module) {
                var allFormActions = moduleObj.data.formWebAudiences;
                var applicableForms = moduleObj.data.selections.applicableForms;

                var formAudiencesFromApplicableForms = _(applicableForms).chain().pluck("formAudiences").flatten().uniq().value();

                return _(allFormActions).filter(function (formAction) {
                    return formAudiencesFromApplicableForms.indexOf(formAction.guid) != -1;
                });
            },

            getApplicableFormAudiencesCopy: function (module) {
                var allFormActions = moduleObj.data.formWebAudiences;
                var applicableForms = moduleObj.data.selections.applicableForms;

                var formAudiencesFromApplicableForms = _(applicableForms).chain().pluck("formAudiences").flatten().uniq().value();

                return _(allFormActions).filter(function (formAction) {
                    return formAudiencesFromApplicableForms.indexOf(formAction.guid) != -1;
                });
            },

            getApplicableFormsForAction: function (module, formAction) {
                var applicableForms = moduleObj.data.selections.applicableForms;

                return _(applicableForms).filter(function (form) {
                    return form.formAudiences.indexOf(formAction.guid) != -1;
                });
            },

            getFormActionSubitem: function (module, form) {
                var itemTemplate = moduleObj.actions.getTemplateFromElement(module.$actionExpandableSubItem);

                itemTemplate = itemTemplate.replace(/\{0\}/g, form.formId);
                itemTemplate = itemTemplate.replace(/\{1\}/g, form.documentTitle);

                return itemTemplate;
            },

            getFormActionSubitemCopy: function (module, form) {
                var itemTemplate = moduleObj.actions.getTemplateFromElement(module.$actionExpandableSubItemWithChildren);

                itemTemplate = itemTemplate.replace(/\{0\}/g, form.formId);
                itemTemplate = itemTemplate.replace(/\{1\}/g, form.documentTitle);
                itemTemplate = itemTemplate.replace(/\{2\}/g, form.documentDescription);

                var buttonTemplate;
                if (form.digitalSignatureUrl != null) {
                    buttonTemplate = moduleObj.actions.getTemplateFromElement(module.$formDownloadMultipleButtonTemplate);
                    buttonTemplate = buttonTemplate.replace(/\{0\}/g, form.digitalSignatureUrl);
                    buttonTemplate = buttonTemplate.replace(/\{1\}/g, form.documentURL);
                } else {
                    buttonTemplate = moduleObj.actions.getTemplateFromElement(module.$formDownloadSingleButtonTemplate);
                    buttonTemplate = buttonTemplate.replace(/\{0\}/g, form.documentURL);
                }

                itemTemplate = itemTemplate.replace(/\{3\}/g, buttonTemplate);

                return itemTemplate;
            },


            displayDownloadForForm: function (module, formId, form) {
                moduleObj.actions.resetFormActionsCopy(module);

                var formActions = moduleObj.actions.getApplicableFormAudiencesCopy(module);
                var partialGetSubitem = _.partial(moduleObj.actions.getFormActionSubitemCopy, module);

                for (var x = 0; x < formActions.length; x++) {
                    var formAction = formActions[x];
                    var itemTemplate = moduleObj.actions.getTemplateFromElement(module.$actionSelectorTemplateWithChildren);

                    var applicableFormsForAction = moduleObj.actions.getApplicableFormsForAction(module, formAction);
                    var applicableFormsSubitemsHtml = _(applicableFormsForAction).map(partialGetSubitem);
                    var applicableFormsSubitemHtml = applicableFormsSubitemsHtml.join(""); // Join with nothing, not comma

                    itemTemplate = itemTemplate.replace(/\{0\}/g, x);
                    itemTemplate = itemTemplate.replace(/\{1\}/g, formAction.actionName);
                    itemTemplate = itemTemplate.replace(/\{2\}/g, formAction.guid);
                    itemTemplate = itemTemplate.replace(/\{3\}/g, applicableFormsSubitemHtml);

                    module.$formDownloadSummaryArea.append(itemTemplate);
                }

                $('[data-form-id="' + formId + '"]').addClass('is-active')

                module.$actionExpandableContainer.removeClass(module.settings.disabledClass);
                moduleObj.actions.registerFormActionsEvents(module);
                accordion()
                module.$formDownloadSummaryContainer.removeClass("Box--disabled");
            },

            getTemplateFromElement: function ($element) {
                var elementHtml = $element.html();
                elementHtml = elementHtml.trim();

                return elementHtml;
            }
        }
    }).extend(window.symetra.formDownloadModuleBase));

})();